import UsuarioRepository from "./usuarioRepository"
import SalaRepository from "./salaRepository"
import BlocoRepository from "./blocoRepository"
import ReservaRepository from "./reservaRepository"
import justificativaRepository from "./justificativaRepository"

const repositories = {
  usuario: UsuarioRepository,
  sala: SalaRepository,
  bloco: BlocoRepository,
  reserva: ReservaRepository,
  justificativa: justificativaRepository,
}

export const RepositoryFactory = {
  get: (name) => repositories[name],
}
